import HouseIcon from '@propertypal/shared/src/resources/icons/new-homes/house.svg';
import Button from '@propertypal/web-ui/src/buttons/Button';

import Link from 'next/link';
import React from 'react';
import { MoreDevelopmentsGroup, MoreDevelopmentsText } from './ShowHomesMoreDevelopments.style';

interface ShowHomesMoreDevelopmentsProps {
  totalDevelopments: number;
}

const ShowHomesMoreDevelopments: React.FC<ShowHomesMoreDevelopmentsProps> = ({ totalDevelopments }) => {
  return (
    <MoreDevelopmentsGroup>
      <MoreDevelopmentsText>
        <HouseIcon />

        <div>
          <h4>Still looking for that perfect new home?</h4>
          <p>
            Browse through our list of <b>{totalDevelopments} developments</b>
          </p>
        </div>
      </MoreDevelopmentsText>

      <Link href="/new-developments" prefetch={false}>
        <Button containerStyle={{ minWidth: 260 }}>View all Developments</Button>
      </Link>
    </MoreDevelopmentsGroup>
  );
};

export default ShowHomesMoreDevelopments;
